import {
  search as publicSearch,
  autocomplete as publicAutocomplete,
  suggest as publicSuggest,
} from './search-platformized-v1-site-document-wix-site-search.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const search: MaybeContext<
  BuildRESTFunction<typeof publicSearch> & typeof publicSearch
> = /*#__PURE__*/ createRESTModule(publicSearch);
/** @internal */
export const autocomplete: MaybeContext<
  BuildRESTFunction<typeof publicAutocomplete> & typeof publicAutocomplete
> = /*#__PURE__*/ createRESTModule(publicAutocomplete);
/** @internal */
export const suggest: MaybeContext<
  BuildRESTFunction<typeof publicSuggest> & typeof publicSuggest
> = /*#__PURE__*/ createRESTModule(publicSuggest);

export {
  SortOrder,
  ScalarType,
  NestedAggregationType,
  AggregationType,
  DocumentType,
} from './search-platformized-v1-site-document-wix-site-search.universal.js';
export {
  SiteDocument,
  SearchRequest,
  Search,
  SearchPagingMethodOneOf,
  Sorting,
  Aggregation,
  AggregationKindOneOf,
  ValueAggregation,
  ScalarAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  SearchDetails,
  Paging,
  SearchResponse,
  SearchResponsePagingOneOf,
  AggregationData,
  ValueAggregationResult,
  ValueResults,
  AggregationResultsScalarResult,
  ValueResult,
  ScalarResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  NestedResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  PagingMetadata,
  AutocompleteRequest,
  AutocompleteResponse,
  AutocompleteResponseValue,
  SuggestRequest,
  Suggest,
  SuggestPagingMethodOneOf,
  SuggestDetails,
  SuggestResponse,
  SearchOptions,
  SiteDocumentSearchSpec,
  AutocompleteOptions,
  SuggestOptions,
} from './search-platformized-v1-site-document-wix-site-search.universal.js';
export { utils } from './search-platformized-v1-site-document-wix-site-search.universal.js';
export {
  SortOrderWithLiterals,
  ScalarTypeWithLiterals,
  NestedAggregationTypeWithLiterals,
  AggregationTypeWithLiterals,
  DocumentTypeWithLiterals,
  CommonSearchWithEntityContext,
  SiteDocumentSearch,
} from './search-platformized-v1-site-document-wix-site-search.universal.js';
